export default "__VITE_ASSET__DPj$x3YP__"